export default __webpack_public_path__ + "static/slide3-en@2x-72bac5ba9cfced5d47c3a861d48ef5b2.png";